module.exports = __webpack_public_path__ + "static/media/ksd.logo.240w.d95c5d93.png";